<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import ManageTokenService from '@/services/ManageTokenService';

export default {
  name: 'app',
  computed: {
    afterAuthorizationUrl() {
      return this.$store.getters['authServicesPoints/afterAuthorizationUrl'];
    },
  },
  watch: {
    afterAuthorizationUrl(url) {
      ManageTokenService.removeTokenFromStorage();
      window.location.href = url;
    },
  },
};
</script>

<style lang="sass" scoped>
  #app
    width: 100%
    height: 100%
    display: flex
</style>



// WEBPACK FOOTER //
// src/App.vue